import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

import type { ToggleListState } from "./ToggleListState";

const ToggleListStateContext = createContext<null | ToggleListState>(null);

export const ToggleListStateContextProvider = ToggleListStateContext.Provider;

export const useToggleListState = (): ToggleListState =>
	useRequiredContext(ToggleListStateContext, {
		providerName: "ToggleListStateProvider",
	});
